import { ChildService } from '../../../../@types/order-service';
import {
  isValidService,
  mapChildServices,
  parseNumber,
} from '../../OrderService/CreateOrderServiceForm/parseOrderServiceForm';
import { BudgetFormDTO } from './BudgetFormDTO';
import { CreateBudgetInput } from './interfaces';

/**
 * Converte os valores do formulário para o formato aceito no envio do orçamento.
 * @param formValues - Dados do formulário do Orçamento.
 * @returns Objeto formatado para a criação do Orçamento.
 */
export const parseBudgetForm = (
  formValues: BudgetFormDTO,
): CreateBudgetInput => {
  const { customer, services, vehicle } = formValues;

  const productTable = mapChildServices(
    services.productTable,
    'Produto',
  ).filter(service => isValidService(service));
  const serviceTable = mapChildServices(
    services.serviceTable,
    'Serviço',
  ).filter(service => isValidService(service));

  const child_services: ChildService[] = [...productTable, ...serviceTable];

  const result: CreateBudgetInput = {
    // cliente
    comment: services.comment,
    discount: parseNumber(services.discount, true),
    document: customer.document,
    name: customer.name,
    phone: customer.phone,
    // serviços
    child_services,
    image_urls: services.images.map(img => img.img_url),
    validity: services.validity.length > 0 ? services.validity : '7 dias',
  };

  // veículo
  if (vehicle.plate) {
    result.km = parseNumber(vehicle.km.replaceAll('.', ''));
    result.plate = vehicle.plate;
    result.chassi = vehicle.chassi;
    result.vehicle = vehicle.vehicle;
  }

  return result;
};
